<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to Company Settings" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-btn dark icon v-if="hasEditRights" @click="dialogEditLogo=true" title="Change company logo">
                        <v-icon>photo_camera</v-icon>
                    </v-btn>
                    <v-btn dark icon title="Edit Company Details" v-if="hasEditRights" @click="showEditCompany">
                        <v-icon small>edit</v-icon>
                    </v-btn>
                    <help-link appId="company" pageId="account" color="white"></help-link>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>
            
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>  

            <v-expansion-panel v-model="panel" class="mt-5" expand>
                <!-- company details -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-10px':''">COMPANY DETAILS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1 transparent"> 
                        <v-card-text v-if="!loading" >
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Company :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                                {{company.name}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Address : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{company.address}}, {{company.city}}, {{company.province}}, {{company.zipCode}}                                          
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Phone : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{company.phone}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Cellphone : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{company.cellphone}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Industry : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{company.industry}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            TIN :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{companyTIN}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Branch Code : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{company.branchCode}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            RDO : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{company.rdo}}
                                        </v-flex>  
                                    </v-layout>
                                    <!-- <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Teams : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{company.teamCount}}
                                        </v-flex>  
                                    </v-layout>
                                     <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Users : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{company.userCount}}
                                        </v-flex>  
                                    </v-layout> -->
                                    <!-- <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Date Created :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            
                                        </v-flex>  
                                    </v-layout> -->
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                
                <!-- account details -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-10px':''">ACCOUNT</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1 transparent"> 
                        <v-card-text v-if="!loading" >
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Account Plan :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{account.accountName}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Account Number :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{account.accountNumber}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Registration Date :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">      
                                            {{account.registrationDate | moment('MMMM DD, YYYY') }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout v-if="account.accountKey == accountTypeKeys.Trial" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Trial Expiration :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">      
                                            {{account.expirationDate | moment('MMMM DD, YYYY') }}
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Active Users :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{account.activeEmployees}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Inactive Users :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{account.inactiveEmployees}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout v-if="account.accountKey == accountTypeKeys.Trial" :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Trial Remaining Days :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">      
                                            <span v-if="account.remainingTrialDays>0">{{account.remainingTrialDays}} days</span>
                                            <span v-else>0 days</span>
                                        </v-flex>
                                    </v-layout>
                                    <!-- <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Teams :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{account.teamCount}}
                                        </v-flex>  
                                    </v-layout> -->
                                    <!-- onhold feature, if expired do not allow to login, show message to contact support@sweldonow.ph -->
                                    <!-- <v-layout v-if="account.accountKey==accountTypeKeys.trial||account.accountKey==accountTypeKeys.free" :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left"></v-flex>
                                        <v-flex xs8 class="text-xs-left">
                                            <v-btn class="primary" @click="dialogUpgrade=true">
                                                <v-icon>upgrade</v-icon>
                                                UPGRADE PLAN
                                            </v-btn>
                                        </v-flex>
                                    </v-layout> -->
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
            
            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogAddEdit" persistent width="700">
            <add-edit-company ref="addEditCompanyRef" :dialogAddEdit.sync="dialogAddEdit" @send="getCompanyDetails(false)"></add-edit-company>
        </v-dialog>
        <v-dialog v-model="dialogEditLogo" fullscreen hide-overlay transition="dialog-bottom-transition"> 
            <edit-company-logo :dialogEditLogo.sync="dialogEditLogo" v-on:send="refreshLogo"></edit-company-logo>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import common from '@/common/functions'
import companyApi from '@/api/company'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import accountTypeKeys from '@/common/accountTypeKeys'
import { hasEditRights } from '@/helpers/access-permissions'

export default {     
    name: 'CompanyAccount',
    metaInfo: {
        title: 'Company Account',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View Company Name, Current Plan, Number of Teams, Number of Users and Timezone' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit-company': () => import("@/components/Company/AddEditCompanyDetails"),
        'edit-company-logo': () => import("@/components/Company/EditCompanyLogo"),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            error: false,
            errorMessage: '',
            message: null,
            loading: false,
            company: null,
            account: null,
            panel: [true],
            toggle_view: 0,
            dialogAddEdit: false,
            dialogEditLogo: false,
            accountTypeKeys: null
        }
    },
    methods: {    
        showUpgradeConfirmation() {},
        async refreshLogo() {
            await this.getCompanyDetails(false)
        },
        showEditCompany() {
            this.$refs.addEditCompanyRef.setParams(this.company)
            this.dialogAddEdit = true
        },
        async getCompanyDetails(show_loading) {
            try{
                this.loading = show_loading
                const response = await companyApi.get()
                if (response && response.status == 200) {
                    this.company = response.data.company
                    this.account = response.data.account
                    this.$store.commit('setCompanyLogo', response.data.company.logoFileName)
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loading = false
            }
        },
        updateHandler(data) {
            this.getCompanyDetails(false)
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Company Account'
        })

        await this.getCompanyDetails(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Company Account',
            companyLogo: common.getCompanyLogoUrl()
        })
        this.accountTypeKeys = accountTypeKeys
    },
    computed: {
        companyIdStr() {
            return this.$store.state.companyId
        },
        pageQueryId() {
            return `${this.companyIdStr}_company_account`
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.company,
                    notificationTypeId: notificationTypes.company_account
                }
            }
        },
        headerImage() {
            return this.$store.state.headerImg
        },
        companyLogoPath() {
            return process.env.VUE_APP_COMPANY_LOGO_URL
        },
        companyLogoFile() {
            if (this.company) return this.company.logoFileName
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        page_title_class() {
            if (this.isMobile) return 'margin:18px 0px 0px 22px;'
            else return 'margin:5px 0px 0px 30px;'
        },
        companyTIN() {
            if (this.company.companyTIN) return `${this.company.companyTIN.substring(0,3)}-${this.company.companyTIN.substring(3,6)}-${this.company.companyTIN.substring(6,9)}`
            return ''
        }
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 20px 0px 50px;
}
.section-layout-mobile {
    padding:0px 10px 0px 10px;
}
</style>